import { render, staticRenderFns } from "./User-Selector.vue?vue&type=template&id=56292524&scoped=true&lang=pug"
import script from "./User-Selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./User-Selector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./User-Selector.vue?vue&type=style&index=0&id=56292524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56292524",
  null
  
)

export default component.exports